/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:fms` or
 *    `npm run generate:graphql:fms:local` in the terminal
 */

import * as Types from '../../../../../types/FMSGraphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentMissingInfoFragmentDoc } from './ShipmentMissingInfoFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ILoadsNeedingAttentionQueryVariables = Types.Exact<{
  first?: Types.Maybe<Types.Scalars['Int']>
  before?: Types.Maybe<Types.Scalars['String']>
  after?: Types.Maybe<Types.Scalars['String']>
  filters?: Types.Maybe<Array<Types.IShipmentMissingInfo> | Types.IShipmentMissingInfo>
}>

export type ILoadsNeedingAttentionQuery = { __typename?: 'Query' } & {
  shipmentsMissingInfo: { __typename?: 'ShipmentMissingInfoConnection' } & Pick<
    Types.IShipmentMissingInfoConnection,
    'totalCount'
  > & {
      nodes?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'Shipment' } & Pick<
              Types.IShipment,
              'id' | 'marketplaceId' | 'missingInfo' | 'missingInfoUrgencyMessage'
            > & {
                stops: Array<
                  { __typename?: 'Stops' } & Pick<
                    Types.IStops,
                    'id' | 'displayTimezone' | 'stopType' | 'stopSequence' | 'startAt' | 'endAt'
                  > & {
                      address: { __typename?: 'Address' } & Pick<
                        Types.IAddress,
                        'locality' | 'subdivisionCode'
                      >
                    }
                >
              }
          >
        >
      >
      pageInfo: { __typename?: 'PageInfo' } & Pick<Types.IPageInfo, 'endCursor' | 'startCursor'>
    }
}

export const LoadsNeedingAttentionDocument = gql`
  query LoadsNeedingAttention(
    $first: Int
    $before: String
    $after: String
    $filters: [ShipmentMissingInfo!]
  ) {
    shipmentsMissingInfo(
      activeLoads: true
      first: $first
      before: $before
      after: $after
      filters: $filters
    ) {
      nodes {
        ...ShipmentMissingInfo
      }
      pageInfo {
        endCursor
        startCursor
      }
      totalCount
    }
  }
  ${ShipmentMissingInfoFragmentDoc}
`

/**
 * __useLoadsNeedingAttentionQuery__
 *
 * To run a query within a React component, call `useLoadsNeedingAttentionQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadsNeedingAttentionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadsNeedingAttentionQuery({
 *   variables: {
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLoadsNeedingAttentionQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ILoadsNeedingAttentionQuery,
    ILoadsNeedingAttentionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ILoadsNeedingAttentionQuery, ILoadsNeedingAttentionQueryVariables>(
    LoadsNeedingAttentionDocument,
    options
  )
}
export function useLoadsNeedingAttentionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ILoadsNeedingAttentionQuery,
    ILoadsNeedingAttentionQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ILoadsNeedingAttentionQuery, ILoadsNeedingAttentionQueryVariables>(
    LoadsNeedingAttentionDocument,
    options
  )
}
export type LoadsNeedingAttentionQueryHookResult = ReturnType<typeof useLoadsNeedingAttentionQuery>
export type LoadsNeedingAttentionLazyQueryHookResult = ReturnType<
  typeof useLoadsNeedingAttentionLazyQuery
>
export type LoadsNeedingAttentionQueryResult = Apollo.QueryResult<
  ILoadsNeedingAttentionQuery,
  ILoadsNeedingAttentionQueryVariables
>
